import { useEffect, useState } from "react";

import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Heading,
  Box,
  Spinner
} from "@/storybook-components";

const ContentDrawer = ({
  isOpen,
  onClose,
  header,
  content,
  footer,
  trapFocus,
  zIndex,
  onCloseComplete
}): JSX.Element => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let timer;
    if (isOpen) {
      timer = setTimeout(() => {
        setIsLoading(false);
      }, 1500);
    } else {
      setIsLoading(true);
    }

    return () => {
      // eslint-disable-next-line no-undef
      clearTimeout(timer);
    };
  }, [isOpen]);

  return (
    <Drawer
      isOpen={isOpen}
      placement="right"
      onClose={onClose}
      onCloseComplete={onCloseComplete}
      variant="primary"
      trapFocus={trapFocus || false}
    >
      <DrawerOverlay zIndex={zIndex} />
      <DrawerContent
        containerProps={{
          zIndex
        }}
        background="gray.100"
        py={6}
      >
        <DrawerCloseButton color="gray.800" mt={2} />

        <DrawerHeader px={4} pt={0} pb={6}>
          <Heading
            size="md"
            fontSize="md"
            fontWeight="semibold"
            lineHeight="shorter"
          >
            {header}
          </Heading>
        </DrawerHeader>

        <DrawerBody p={0}>
          {isLoading ? (
            <Box
              px={4}
              h="90%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              color="gray.300"
            >
              <Spinner size={{ base: "lg", md: "xl" }} />
            </Box>
          ) : (
            content
          )}
        </DrawerBody>

        {footer && (
          <DrawerFooter px={0} pt={6} pb={0}>
            {footer}
          </DrawerFooter>
        )}
      </DrawerContent>
    </Drawer>
  );
};

export default ContentDrawer;
